const PREFIX = 'portal-onboarding';
const SESSION_PREFIX = 'portal-onboarding-session';

/**
 * @param {number} userId
 * @param {string} role
 */
function key(userId, role) {
  return `${PREFIX}:${userId}:${role}`;
}

/**
 * @param {number} userId
 * @param {string} role
 */
function sessionKey(userId, role) {
  return `${SESSION_PREFIX}:${userId}:${role}`;
}

/**
 * @param {number} userId
 * @param {string} role
 * @returns {'pending' | 'completed' | 'dismissed' | null}
 */
export function getOnboardingStatus(userId, role) {
  try {
    return localStorage.getItem(key(userId, role));
  } catch {
    return null;
  }
}

/**
 * @param {number} userId
 * @param {string} role
 * @param {'completed' | 'dismissed'} status
 */
export function setOnboardingStatus(userId, role, status) {
  try {
    localStorage.setItem(key(userId, role), status);
  } catch {
    // ignore
  }
}

export function clearOnboardingStatus(userId, role) {
  try {
    localStorage.removeItem(key(userId, role));
    sessionStorage.removeItem(sessionKey(userId, role));
  } catch {
    // ignore
  }
}

/**
 * @param {number} userId
 * @param {string} role
 */
export function snoozeOnboardingForSession(userId, role) {
  try {
    sessionStorage.setItem(sessionKey(userId, role), '1');
  } catch {
    // ignore
  }
}

/**
 * @param {number} userId
 * @param {string} role
 */
export function isOnboardingSnoozedForSession(userId, role) {
  try {
    return sessionStorage.getItem(sessionKey(userId, role)) === '1';
  } catch {
    return false;
  }
}
